import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { handleDropdownMenuContainerKeydown } from 'app/shared/utils/dropdown-menu-keyboard.util';

@Component({
  selector: 'kh-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DropdownMenuComponent {
  private static nextId = 0;

  private readonly dropdownId = DropdownMenuComponent.nextId++;

  public readonly buttonId = `dropdown-menu-button-${this.dropdownId}`;
  public readonly menuId = `dropdown-menu-list-${this.dropdownId}`;

  @Input() public label?: string;
  @Input() public triggerA11yLabel?: string;
  @Input() public alignmentRight = false;
  public isOpen = false;

  public get triggerAccessibleName(): string | null {
    return this.triggerA11yLabel || this.label || null;
  }

  public onMenuKeydown(event: KeyboardEvent, dropdown: { hide(): void }): void {
    handleDropdownMenuContainerKeydown(event, () => dropdown.hide());
  }
}
